function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 7.13388V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H12.8661C12.9482 3.125 13.0295 3.14117 13.1053 3.17258C13.1811 3.20398 13.25 3.25002 13.3081 3.30806L16.6919 6.69194C16.75 6.74998 16.796 6.81888 16.8274 6.89471C16.8588 6.97053 16.875 7.05181 16.875 7.13388Z",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14.3762C11.2081 14.3762 12.1875 13.3968 12.1875 12.1887C12.1875 10.9806 11.2081 10.0012 10 10.0012C8.79188 10.0012 7.8125 10.9806 7.8125 12.1887C7.8125 13.3968 8.79188 14.3762 10 14.3762Z",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 7.50122H7.5V3.12622",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.40b21bd908f9d992286cc3cf79e1d910.svg";
export { ForwardRef as ReactComponent };